module.exports = __webpack_public_path__ + "img/aeiou_0.23c4de9b.png";